export default __webpack_public_path__ + "static/media/img_persona.d013ca61.png";